"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.812 15.5a.736.736 0 0 1-.356-.095l-.003-.001a.745.745 0 0 1-.383-.645V5.626l1.83-1.6-.292-1.791L12.7.425l.458 2.807L15.93 5.62v9.138a.743.743 0 0 1-.375.639.733.733 0 0 1-.367.102H.812Zm12.02-8.042-.96-5.884L2.757 3.06l.77 4.724L5.66 9.999h4.58l2.592-2.541ZM2.089 5.176l.223 1.37-.838-.852.615-.518Zm12.842 8.667-3.191-3.37-.726.688 3.163 3.339H1.826l3.163-3.34-.726-.687-3.193 3.372V6.72l4.167 4.278h5.413l4.28-4.271v7.115Zm-.398-8.145-.831.867-.296-1.817 1.127.95Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m19.628 4.883 4.184 3.53v13.82a.93.93 0 0 1-.47.8l-.001.002a.913.913 0 0 1-.457.126H1.116a.914.914 0 0 1-.448-.121.925.925 0 0 1-.48-.806V8.418L2.974 6.06l-.43-2.63L18.955.756l.674 4.127Zm-.102 6.364-1.5-9.2L3.835 4.36l1.208 7.407 3.332 3.455h7.097l4.053-3.975ZM3.185 7.354l.492 3.02-1.845-1.879 1.353-1.141Zm19.503 13.981-5.169-5.457-.816.773 5.1 5.385H2.2l5.099-5.385-.816-.773-5.17 5.46V9.571l2.8 2.85 3.784 3.925h8.036l6.755-6.758v11.746ZM22.174 8.5l-1.672 1.743-.595-3.654L22.174 8.5Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m26.171 6.51 5.579 4.708v18.427c0 .436-.241.844-.627 1.067h-.002a1.218 1.218 0 0 1-.609.17H1.488c-.204 0-.405-.055-.597-.162l-.001-.001a1.234 1.234 0 0 1-.64-1.074V11.224L3.965 8.08l-.572-3.506 21.88-3.566.898 5.503Zm-.136 8.486L24.034 2.729 5.115 5.814l1.61 9.875 4.443 4.607h9.463l5.404-5.3ZM4.246 9.805l.656 4.026-2.46-2.504 1.804-1.522ZM30.25 28.447l-6.891-7.276-1.088 1.03 6.799 7.18H2.933l6.799-7.18-1.088-1.03L1.75 28.45V12.763l3.735 3.8 5.045 5.233h10.714l9.006-9.01v15.66Zm-.685-17.113-2.229 2.323-.794-4.872 3.023 2.549Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.687 46.658a1.66 1.66 0 0 1-.813-.222c-.54-.3-.874-.862-.874-1.465v-28.24l5.729-4.829-.865-5.298L38.08 1.19l1.358 8.328L48 16.731v28.24c0 .594-.328 1.151-.855 1.453v.001h-.002a1.656 1.656 0 0 1-.83.233H1.687ZM39.66 22.526 36.532 3.34 7.016 8.153l2.522 15.462 6.941 7.198h14.73l8.45-8.287ZM6.08 14.058l1.18 7.236-4.423-4.501 3.243-2.735ZM46.126 43.67 35.159 32.09l-1.362 1.289 10.8 11.404H3.408l10.8-11.404-1.36-1.288L1.873 43.676V18.488l6.114 6.22 7.694 7.98h16.293l14.15-14.174v25.157Zm-.954-26.87-3.886 4.05-1.386-8.49 5.271 4.442Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 62.211c-.369 0-.732-.1-1.084-.296A2.246 2.246 0 0 1 0 59.962V22.309l7.639-6.44-1.153-7.063 44.287-7.22 1.81 11.104L64 22.309v37.653c0 .792-.437 1.534-1.14 1.937v.001h-.002l-.002.001c-.357.205-.73.31-1.105.31H2.249Zm50.63-32.177-4.171-25.58L9.355 10.87l3.362 20.617 9.255 9.597h19.64l11.267-11.05ZM8.106 18.744l1.573 9.648-5.897-6.001 4.324-3.647ZM61.5 58.228 46.878 42.79l-1.815 1.718 14.4 15.205H4.543l14.4-15.205-1.814-1.718-14.63 15.447V24.65l8.152 8.294L20.91 43.583h21.723L61.5 24.686v33.542Zm-1.272-35.826-5.181 5.4L53.2 16.479l7.028 5.923Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconEnvelopeMail = function IconEnvelopeMail(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Envelope Mail' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "EnvelopeMail"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconEnvelopeMail.sizes = [16, 24, 32, 48, 64];
IconEnvelopeMail.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconEnvelopeMail;
exports.default = _default;